import React, { useEffect, useRef, useState,  } from 'react';
import { useDispatch } from 'react-redux';
import ReactDOM from 'react-dom';
import {
  Box, Button,
  Toolbar,
  IconButton,
  Typography,
} from '@mui/material';
import { Close, CloudDownload } from '@mui/icons-material';
import { getFileType, getIsOfficelType } from '@ivymobi/orbit-core';
import _, { get } from 'lodash';
import PDFViewer from './pdfViewer';
import MobilePDFViewer from './mobilePdfViewer';
import { useTranslation } from 'react-i18next';

import {
  setBrowseTimeAction, 
} from '@ivymobi/orbit-core/business/document';
import ReactPdfViewer from '../components/Viewer/ReactPdfViewer';
import IVideo from '../components/IVideo';
// const PDFViewer = lazy(
//   () => import('./pdfViewer' /* webpackChunkName: "pdfViewer" */)
// );

function UnsuppotPreview ({ document ,handleDownload}) {
  const [t] = useTranslation();
  return (
    <Box height='100%' display='flex' flexDirection='column'
      alignItems='center' justifyContent='center'
    >
      <Typography paragraph style={{color: 'white'}}>
        {/* 当前不支持该文件的在线查看，请下载后查看 */}
        {t('common.NoFileView')}
      </Typography>
      <Button variant='outlined' style={{background:'white'}} color='primary' onClick={()=>{
          if(handleDownload){
            handleDownload()
          }
          const a = window.document.createElement('a')
          window.document.body.appendChild(a)
          a.style = 'display: none'
          a.href = document?.asset?.url
          a.download = document?.asset?.name
          a.click()
          window.URL.revokeObjectURL(document?.asset?.url)
      }}>下载文件</Button>
    </Box>
  );
}

function CantView ({ document }) {
  const [t] = useTranslation();
  // const { asset: { url }, name } = document;
  return (
    <Box height='100%' display='flex' flexDirection='column'
      alignItems='center' justifyContent='center'
    >
      <Typography paragraph style={{color: 'white'}}>
        {/* 当前不支持该文件的在线查看，请下载后查看 */}
        {t('common.NoDownloadFileView')}
      </Typography>
    </Box>
  );
}

function PhotoPreview ({ document }) {
  const url = document.asset.url;
  return (
    <Box flex={1}
      display='flex' alignItems="center" justifyContent='center'
      padding={3}
    >
      <img
        draggable={false}
        onContextMenu={(e) => {e.preventDefault();}}
        src={url}
        style={{
          objectFit: 'contain',
          maxWidth: '100%',
          maxHeight: 'calc(100vh - 130px)',
        }}
      />
    </Box>
  );
}

function VideoPreview ({ document ,user }) {
  const url = document.asset.url;
  return (
    <Box display='flex' alignItems='center' justifyContent='center' flex={1} onContextMenu={e => e.preventDefault()} >
      <IVideo watermarkText={document?.acl?.videoWatermarkable?(user?.user?.phone??'匿名用户'):''} controls controlsList="nodownload" style={{ maxWidth: '100%', maxHeight: '520px' }} >
        <source src={url}></source>
      </IVideo>
    </Box>
  );
}

function HTMLViwer ({document}) {
  const { acl } = document;
  const { urlstr } = acl;
  return (
    <Box style={{width: '100%', height: '100%', minHeight: 'calc(100vh - 115px)', padding: '0 20px'}}>
      <iframe
        style={{width:'100%', height: '100%', minHeight: 'calc(100vh - 115px)'}}
        onLoad={(res) => {
          // const obj = ReactDOM.findDOMNode(this);
          // console.log(res);
          // this.setState({
          //   'iFrameHeight':  obj.contentWindow.document.body.scrollHeight + 'px'
          // });
        }}
        // ref="iframe"
        src= {urlstr}
        width="100%"
        height="100%"
        // height={this.state.iFrameHeight}
        // scrolling="no"
        frameBorder="0"
      />
    </Box>
  );
}

function OfficelViwer ({document,handleDownload}) {
  const [t] = useTranslation();
  return (
    <Box height='100%' display='flex' flexDirection='column'
      alignItems='center' justifyContent='center'
    >
      <Typography paragraph style={{color: 'white'}}>
        {/* 当前不支持该文件的在线查看，请下载后查看 */}
        {t('common.NoOfficeFileView')}
      </Typography>
      <Button variant='outlined' style={{background:'white'}} color='primary' onClick={()=>{
          if(handleDownload){
            handleDownload()
          }
          const a = window.document.createElement('a')
          window.document.body.appendChild(a)
          a.style = 'display: none'
          a.href = document?.asset?.url
          a.download = document?.asset?.name
          a.click()
          window.URL.revokeObjectURL(document?.asset?.url)
      }}>下载文件</Button>
    </Box>
  );
}

// -------mode------ 定时任务组件
export const UseSetInterval =  (cb, time = 1000) => {
  const cbRef = useRef();
  useEffect(() => {
    cbRef.current = cb;
  });
  useEffect(() => {
    const callback = () => {
      cbRef.current?.();
    };
    const timer = setInterval(() => {
      callback();
    }, time);
    return () => clearInterval(timer);
  }, []);
};

export function Preview (props) {
  const {
    type, handleDownload, document, share, isPreview, onLikeFormOpen, onClose, user, tenant, 
    eventID,parentRef,handleSendToEmail
  } = props;
  const dispatch = useDispatch();
  // const [tenant, setTenant] = useState(null);
  const fileType = document.type === 'weblink'? 'weblink' : getFileType(get(document, 'asset.filename'));
  const isOfficel = getIsOfficelType(fileType);
  // if (share !== undefined) {
  //   if (share?.acl?.downloadable === false) {
  //     return <CantView document={document} />;
  //   }
  // }


  // --------------------------------------文件阅读计时器   ----mode----文件浏览时长    ----------------------------------------
  // 一个定时事件使count累加，
  // count变化时将浏览时长发送给后台对应ID的埋点事件

  const [count, setCount] = useState(0);
  const time = 5000;
  // console.log('计数器启动————————————————————————————————————————', count);
  UseSetInterval(() => {
    if(_.isEmpty(eventID))
      return;
    setCount(count + 1);
  }, time);
  // count 每次变化时间增加5S
  useEffect(() => {
    if (_.isEmpty(eventID) || count === 0) return;
    console.log('eventIDeventIDeventIDeventIDeventID', eventID);
    dispatch(setBrowseTimeAction({user, tenant, eventID: eventID, time: count * time}));
  }, [dispatch, eventID, count]);

  // ------------------------------------------end--------------------------------------------------





  if (fileType === 'photo') {
    return (
      <PhotoPreview document={document} />
    );
  }

  if (fileType === 'video') {
    return <VideoPreview document={document} user={user}/>;
  }
  const  IsPC = () => {
    const userAgentInfo = navigator.userAgent;
    const Agents = ['Android', 'iPhone',
      'SymbianOS', 'Windows Phone',
      'iPad', 'iPod'];
    let flag = true;
    for (let v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false;
        break;
      }
    }
    return flag;
  };
  if (fileType === 'pdf') {
    if ( !IsPC() && type && (type==='share')) {
      return <ReactPdfViewer
        parentRef={parentRef}
        tenant={tenant}
        user={user}
        document={document}
        share={share}
        handleDownload = {handleDownload}
        handleSendToEmail={handleSendToEmail}
        onLikeFormOpen={onLikeFormOpen}

        onClose={onClose}
        errorPlugin={
          (e)=>{
            return <Box style={{height:'100%',display:'flex',justifyContent:"center",alignItems:'center'}}>
              <Box style={{color:'white',fontSize:'20px'}}>
                <img src='/fileTypes/pdf.svg'></img>
                {e.message==='Failed to fetch'?"PDF不存在或已过期!":"升级至IOS15才能正常预览PDF文件!"}
              </Box>
              
            </Box>
          }
        }
      />;
    } else
      return <ReactPdfViewer
        parentRef={parentRef}
        tenant={tenant}
        user={user}
        document={document}
        share={share}
        handleDownload = {handleDownload}
        handleSendToEmail={handleSendToEmail}
        onLikeFormOpen={onLikeFormOpen}

        onClose={onClose}
        errorPlugin={
          (e)=>{
            return <Box style={{height:'100%',display:'flex',justifyContent:"center",alignItems:'center'}}>
              <Box style={{color:'white',fontSize:'20px'}}>
                <img src='/fileTypes/pdf.svg'></img>
                {e.message==='Failed to fetch'?"PDF不存在或已过期!":"升级至IOS15才能正常预览PDF文件!"}
              </Box>
              
            </Box>
          }
        }
      />;
  }

  if (fileType === 'weblink') {
    return (
      <HTMLViwer document={document} user = {user} />
    );
  }

  if (isOfficel) {
    return (
      <OfficelViwer document={document} handleDownload={handleDownload}/>
    );
  }

  return (
    <UnsuppotPreview document={document} handleDownload={handleDownload}/>
  );
}

/**
 *
 * @description 文件预览 dialog 组件
 */
export default function PreviewDialog(props) {
  const {
    handleDownload, document, onClose, isPreview, onLikeFormOpen, share, user, tenant, type,
    eventID,handleSendToEmail
  } = props;
  const parentNode = useRef();

  return (
    <Box style={{height: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around'}}>
      <Preview 
        type={type} 
        handleDownload={handleDownload} 
        tenant={tenant} 
        document={document} 
        onClose={onClose} 
        isPreview={isPreview} 
        onLikeFormOpen={onLikeFormOpen} 
        share={share} 
        user={user}
        parentRef={parentNode}
        handleSendToEmail={handleSendToEmail}
        eventID={eventID}
      />
    </Box>
  );
}
